import React from "react";
import imgHouse0Old from '../../assets/images/slider/house0-old.jpg';
import imgHouse0New from '../../assets/images/slider/house0-new.jpg';
import "../../assets/css/slider.css"
import $ from "jquery"
import { callAnalyticsAPI } from "../../api/user"


class Slider extends React.Component {

    constructor(props) {
        super(props)
        const { pageKey, selMenu, device, sliderObj } = props
        this.state = { pageKey, selMenu, sliderObj, imgOld: imgHouse0Old, imgNew: imgHouse0New }
    }


    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.sliderObj !== nextProps.sliderObj) {
            this.setState({ sliderObj: nextProps.sliderObj })
            this.setSlideSize(50);
            // $(".drag-btn-hover").css("left", "calc(55% - "+0+"px)"); // tSize.h/4

        }

    }

    componentDidMount() {
        this.setSlideSize(50);
        $(".drag-btn-hover").show();
        // $(".drag-btn-hover").css("left", "calc(54% - "+0+"px)"); // tSize.h/4

        document.addEventListener('mouseup', this.onMouseUp);
        document.addEventListener('dragend', this.onMouseUp);
        document.addEventListener('drag', this.downDragBtn);

        document.getElementById('slider').addEventListener('mousemove', (e) => this.onMouseMove(e));
        document.getElementById('slider').addEventListener('touchmove', (e) => this.onTouchMove(e));
        document.getElementById('dragBtn').addEventListener('touchstart', (e) => this.onTouchStart(e));
        document.getElementById('dragBtn').addEventListener('touchend', (e) => this.onTouchEnd(e));
        document.getElementById('dragBtn').addEventListener('mouseup', (e) => this.onMouseUp(e));
        document.getElementById('dragBtn').addEventListener('mousedown', (e) => this.downDragBtn(e));
    }



    onTouchEnd = () => {
        this.setState({ mouseDown: false })
    }

    onTouchStart = () => {
        $(".drag-btn-hover").hide();

        this.setState({ mouseDown: true })
    }

    onMouseUp = () => {
        this.setState({ mouseDown: false })
        $(".drag-btn-hover").hide();
    }

    downDragBtn = () => {
        this.setState({ mouseDown: true })
    }

    upDragBtn = (e) => {
        this.setState({ mouseDown: false })
    }

    onTouchMove = (e) => {
        if (!this.state.mouseDown) return;
        if($(".drag-btn-hover").css('display') != 'none')
        {
            $(".drag-btn-hover").hide();

        }
        ;[...e.changedTouches].forEach(touch => {
            const pro = (touch.pageX - 10) / window.innerWidth * 100;
            if(pro < 96) {    
                this.setSlideSize(pro);
            }

        });
    }

    onMouseMove = (e) => {



        if (!this.state.mouseDown) return;
        if($(".drag-btn-hover").css('display') != 'none')
        {
            $(".drag-btn-hover").hide();
        }
        const pro = (e.pageX - 10) / window.innerWidth * 100;
        if(pro < 97) {
            this.setSlideSize(pro);
        }
    }

    setSlideSize = (pro) => {
        const deltaX = 20;
        // var pro_poup = pro;

        $("#newWrapper").css("clip-path", "polygon( 0 0, calc(" + pro + "% + " + deltaX + "px) 0, calc(" + pro + "% + " + deltaX + "px) 100%, 0 100%, 0 0)");

        if (this.props.device === undefined) {
            $("#dragWrapper").css("left", "calc(" + pro + "% - " + 0 + "px)"); // tSize.h/4
        } else {
            if (pro > 0 && pro < 99) {
                $("#dragWrapper").css("left", "calc(" + pro + "% - " + 0 + "px)"); // tSize.h/4
            }
        }

        let info_calc = $("#dragWrapper").css("left") ;
        let exp_info_calc = info_calc.split("px")
        let width_drag = parseFloat(exp_info_calc[0]) + 90
        $("#dragWrapper2").css("left",`${width_drag}px`)
    }

    render() {
        const { mouseDown, sliderObj } = this.state;
        const { tSize } = this.props;
        if (sliderObj.newImage === "") {
            $("#newWrapper").css("clip-path", "");

        }

        return (
            <div className={`wrapper back-board slider ${this.props.pageKey === 'slider' ? 'active' : ''}`} id='slider' style={{ position: 'absolute', width: tSize.w, height: tSize.h, left: tSize.l }}>
                <img className='img-old' src={sliderObj.oldImage} alt='' onLoad={() => {
                    if (this.props.pageKey === 'slider' && sliderObj.newImage === "") {
                        this.props.changeLoaderStatus(false)
                    }
                }}></img>

                <div className='new-wrapper flex' id='newWrapper'>
                    <img src={sliderObj.newImage} alt='' style={{ width: window.innerWidth }} onLoad={() => {
                        if (this.props.pageKey === 'slider') {
                            this.props.changeLoaderStatus(false)
                        }
                    }}></img>
                    {sliderObj.hotspots && sliderObj.hotspots.map(item =>
                        <div key={item.key} className='hotspots' style={{ top: item.pos.y + '%', left: item.pos.x + '%' }} onClick={() => this.props.setModalPopupContent(item.ref)}></div>
                    )}
                </div>

                {
                    <div style={{ visibility: sliderObj.newImage !== "" ? 'visible' : 'hidden' }}>
                        <div className='drag-wrapper flex' id='dragWrapper'> {/*  style={{width:tSize.h/2}} className={`drag-btn ${mouseDown ? 'active' : ''}`} */}
                            <div className='drag-btn' id='dragBtn'></div>
                        </div>
                        <div className='drag-btn-hover flex' id='dragWrapper2'>
                        Click and drag the slider left and right to see <br />before & after views and learn more about Fypon products
                        </div>
                    </div>
                }
            </div>
        )
    }
}


export default Slider